import { usePaymentDrawerStore } from '@/features/payments/payment-drawer.store'
import { PaymentDrawer } from '@/pages/payments/PaymentDrawer'

/** Mounted in the app shell: shows the record / pay drawer opened through `usePaymentLauncher`. */
export function PaymentDrawerHost() {
  const request = usePaymentDrawerStore((st) => st.request)
  const close = usePaymentDrawerStore((st) => st.close)
  if (!request) return null
  return <PaymentDrawer key={request.key} leaseId={request.leaseId} amount={request.amount} onClose={close} />
}
